import React from 'react';
import { Placeholder } from '../layout';
export const defaultRenderPlaceholder = props => /*#__PURE__*/React.createElement(Placeholder, props);
//# sourceMappingURL=defaultRenderers.js.map